import React, { ReactNode, useEffect } from 'react'
import Drawer from 'react-modern-drawer'
import classnames from 'classnames/bind'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface DrawerProps {
  children: ReactNode
  direction: 'right' | 'left' | 'top' | 'bottom'
  open: boolean
  onClose: () => void
  zIndex?: number
  className?: string
  lockBackgroundScroll?: boolean
  style?: object
}

const DrawerComponent = ({ children, className, style, open, ...restProps }: DrawerProps) => {
  useEffect(() => {
    return () => {
      document.body.style.overflow = 'initial'
    }
  }, [])

  return (
    <Drawer className={cx('drawer', className)} style={{ background: '#f2f2f2', ...style }} open={open} {...restProps} size='auto' zIndex={10000}>
      {open && children}
    </Drawer>
  )
}

export default DrawerComponent
